import script from "./TipAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./TipAlert.vue?vue&type=script&setup=true&lang=ts"

import "./TipAlert.vue?vue&type=style&index=0&id=e35fad7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e35fad7c"]])

export default __exports__